import { fetchApi } from "../../tools";

const get = async ( url, headers, contentParam ) => {
    try {
      const response = await fetchApi({
        url: url,
        headers: headers,
        content: contentParam,
      });
      return response;      
    } catch (error) {
      console.log('sin respuesta')
    }

}

const post = async ( url, headers, contentParam ) => {
  let response;
    try {
      response = await fetchApi({
        method: 'POST',
        url: url,
        headers: headers,
        content: contentParam,
      });
      return response;      
    } catch (error) {
      console.log(error)
      return error
      //console.log('sin respuesta')
     
    }
    //return response

  }

export {
    get,
    post,
}